import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { GlobalStyles } from '@mui/system';

const Copyright = ({ clinicData }) => {
    console.warn('footer received: ', clinicData);
    const theme = useTheme();

    const hasLogo = !!clinicData?.url;
    const hasContactInfo = !!clinicData?.emailAddress || !!clinicData?.clinicNumber;
    // Show contact message if clinic name exists AND at least one contact method exists
    const showContactBlock = !!clinicData?.clinicName && hasContactInfo;
    // Show clinic name fallback ONLY if no logo AND contact message is NOT shown
    const showClinicNameFallback = clinicData?.clinicName && !hasLogo && !showContactBlock;

    return (
        <>
            <GlobalStyles
                styles={{
                    '@page': {
                        size: 'A4 portrait',
                        margin: '0mm',
                        marginTop: '10mm',
                        marginBottom: '10mm',
                    },
                    '.printPageBreak': {
                        pageBreakAfter: 'always',
                    },
                    '@media print': {
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        body: {
                            paddingBottom: theme.spacing(2),
                        },
                        '#handout-content': {
                            position: 'relative',
                            zIndex: 0,
                        },
                        '.MuiBox-root': {
                            position: 'relative',
                            zIndex: 0,
                            pageBreakInside: 'auto',
                        },
                        '.MuiListItem-padding': {
                            pageBreakInside: 'avoid',
                        },
                        'section.title': {
                            marginBottom: '0px!important',
                            marginTop: '0px!important',
                        },
                        '.callout': {
                            marginBottom: '16px!important',
                            pageBreakInside: 'avoid',
                        },
                    },
                }}
            />

            {/* Contact block - shown for both Partner and Platform when clinic name and contact info exist */}
            {showContactBlock && (
                <Box
                    component="footer-top"
                    sx={{
                        mb: 0,
                        mt: 0,
                        '@media print': { display: 'none' },
                    }}
                >
                    <Typography variant="caption" sx={{ fontStyle: 'italic', color: '#666666', fontSize: 12 }}>
                        For any queries, please contact via{' '}
                        {clinicData?.emailAddress && (
                            <>
                                <Link href={`mailto:${clinicData.emailAddress}`} underline="always">
                                    {clinicData.emailAddress}
                                </Link>
                                {clinicData?.clinicNumber && ' or '}
                            </>
                        )}
                        {clinicData?.clinicNumber && <>{clinicData.clinicNumber}</>}.
                    </Typography>
                </Box>
            )}

            {/* Always show footer */}
            <Box
                component="footer"
                sx={{
                    pt: 1,
                    textAlign: 'left',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    '@media print': {
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        bgcolor: 'background.paper',
                        zIndex: 0,
                        overflow: 'visible',
                        py: 0,
                        display: 'none',
                    },
                }}
            >
                <Typography
                    variant="caption"
                    sx={{
                        lineHeight: '1.5',
                        fontSize: 16,
                        '@media print': { fontSize: '6pt', marginBottom: '-9px' },
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 0.5,
                        alignItems: 'center',
                    }}
                >
                    © Copyright Cetra Health. All rights reserved.
                    <Link
                        href={
                            process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet'
                                ? 'https://www.cetravets.com'
                                : 'https://www.cetrahealth.com'
                        }
                        color="inherit"
                        underline="always"
                        sx={{
                            '@media print': {
                                textDecoration: 'none',
                                lineHeight: '1',
                                display: 'inline',
                                marginTop: 0,
                            },
                        }}
                        target="_blank"
                        rel="noopener"
                    >
                        {process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet'
                            ? 'https://www.cetravets.com'
                            : 'https://www.cetrahealth.com'}
                    </Link>
                </Typography>

                {/* Logo or Name */}
                {/* TODO removed showLogo?  */}
                {clinicData && (
                    <>
                        {hasLogo && (
                            <img
                                src={clinicData.url}
                                style={{
                                    position: 'absolute',
                                    right: 10,
                                    bottom: 2,
                                    height: 75,
                                    marginTop: 0,
                                }}
                                alt="Clinic Logo"
                            />
                        )}
                        {showClinicNameFallback && (
                            <Box sx={{ position: 'absolute', right: 10, bottom: 2, fontSize: 16 }}>
                                {clinicData.clinicName}
                            </Box>
                        )}
                    </>
                )}
            </Box>
        </>
    );
};

export default Copyright;
